import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css"


const defaultOptions = {
    title: null,
    credits: {
        enabled: false
    },
    plotOptions: {
        bar: {
            dataLabels: {
                enabled: true,
                color: "#fff",
            },
        },
        series: {
            animation: false,
            groupPadding: 0,
            pointWidth: 20,
            pointPadding: 0,
            dataLabels: {
                style: {
                    fontSize: "16px"
                }
            }
        },
    },
    tooltip: {
        borderRadius: 15,
        borderWidth: 1,
        borderColor: "#707070",
        backgroundColor: "#FFFFFF",
        padding: 17,
        shape: "square",
        style : {
            font: "Arial",
            fontSize: 14,
            color: "#333333",
        },
        formatter() {
            return `Response Type: <b>${this.series.chart.options.series.name}</b>
                <br/>Score Type: <b>${this.key}</b>
                <br/>Score: <b>${this.y}</b>`   
        }
    },
    exporting: { enabled: false }
}

class BarChart extends Component {
  	constructor(props) {
		super(props);
  	}

	render() {
        Highcharts.setOptions(this.props.containerId, {});
        let newDefaultOptions = {...defaultOptions}
        if (this.props.stacking !== null) {
            newDefaultOptions.plotOptions.series = {"stacking": this.props.stacking, animation: false}
        }
        return (
            <div id={this.props.containerId}>
                {this.props.remainingOptions ? <HighchartsReact
                    options = {{
                        ...newDefaultOptions,
                        ...this.props.remainingOptions,
                    }}
                    highcharts = { Highcharts }
                /> : <h1>...loading...</h1>}
            </div>
        )
	}
}


export default BarChart;
